module.exports = __webpack_public_path__ + "static/media/check-icon-green.8b6f8b5f.svg";